<script lang="ts" setup>
  defineProps<{
    addButtonTestId: string
    addLabel: string
    sectionClass?: string
    sectionTestId: string
    subtitle: string
    title: string
  }>()

  const emit = defineEmits<{
    (e: 'add-item'): void
  }>()
</script>

<template>
  <section
    class="flex max-w-225 flex-col gap-2 px-3 pt-2 pb-4.5"
    :class="sectionClass"
    :data-testid="sectionTestId"
  >
    <div class="flex h-7 items-center justify-between gap-2">
      <h2 class="body-xl-medium text-heading! m-0 truncate">
        {{ title }}
      </h2>
      <NButton
        text
        strong
        type="primary"
        class="shrink-0"
        :data-testid="addButtonTestId"
        :theme-overrides="{
          fontSizeMedium: '12px',
        }"
        @click="emit('add-item')"
      >
        {{ addLabel }}
      </NButton>
    </div>

    <p class="body-lg text-body-secondary! m-0 max-w-7/10">
      {{ subtitle }}
    </p>

    <div class="divide-border divide-y">
      <slot />
    </div>
  </section>
</template>
